import { fetchFeaturedArticle } from "../fetches/home_fetch";
import { useQuery } from "react-query";
import "../assets/css/featured.card.css";
import { PopularFeaturedCard } from "./popular.featured.card";

export function FeaturedCard({ data }) {
  return <PopularFeaturedCard data={data} />;
}
